import { render, staticRenderFns } from "./InsightSettings.vue?vue&type=template&id=55e56456&"
import script from "./InsightSettings.vue?vue&type=script&lang=ts&"
export * from "./InsightSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports